import React from 'react';
import PropTypes from 'prop-types';
import ProjectRole from '../project-role';
import Reveal from '../../reveal';
import RevealSlideDown from '../../animations/reveal-slide-down';
import ButtonArrow from '../../button-arrow';
import styles from './project-introduction.module.css';

const IntroductionContent = props => {
  const { content, animation, slug } = props;
  return (
    <React.Fragment>
      <div
        dangerouslySetInnerHTML={{ __html: content }}
        className={styles.desktopContent}
        style={animation}
      />
      {slug === 'weichert-franchising' && (
        <div className={styles.btnWrapper} style={animation}>
          <ButtonArrow
            message={'View Live Site'}
            url={'https://weichertfranchise.com/'}
            external={true}
          />
        </div>
      )}
    </React.Fragment>
  );
};

const ProjectIntroduction = props => {
  const { isInView } = props;

  return (
    <div className={styles.introduction}>
      <div className={styles.contentWrapper}>
        <div
          className={styles.mobileSpacer}
          style={{ height: '45px', width: '100%' }}
        />
        <Reveal>
          <RevealSlideDown isInView={isInView}>
            <IntroductionContent {...props} />
          </RevealSlideDown>
        </Reveal>
      </div>

      <div className={styles.roleWrapper}>
        <Reveal>
          <ProjectRole {...props} />
        </Reveal>
      </div>
    </div>
  );
};

IntroductionContent.propTypes = {
  content: PropTypes.string,
  animation: PropTypes.object,
};

export default ProjectIntroduction;



// WEBPACK FOOTER //
// ./src/components/project/project-introduction/index.js